import styled from "styled-components";
import BackView, {View} from "../../../styles/HeadView";
import {Content} from "../../../styles/GlobalStyles";
import {Link} from "react-router-dom";
import Text from "../../../styles/Text";
import Color from "../../../assets/Colors";
import {CardContactMap} from "../../auth/components/ContactStyles";
import {ContentContainer} from "../../../styles/Products";
import {ActionBio} from "../../course_details/components/FacilitadorStyle";

export const MainContent = styled.div`
   width: 100%;
   margin-top: 0;
   padding-top: 7em;

   @media screen and (max-width: 1600px) {
      padding-top: 4em;
   }
   @media screen and (max-width: 500px) {
      padding: 2em 0;
      width: calc(100% - 4vw);
   }
`;

export const ContentImg = styled(BackView)`
   padding-top: 0;

   & ${Content} {
      display: flex;
      align-items: center;

      & .contentSlide {
         width: 100%;

         & .title {
            font-size: 2.5em;
            font-weight: 100;
         }
      }
   }

   @media screen and (max-width: 1600px) {
      & ${Content} {
         & .contentSlide {
            & .title {
               font-size: 1.8em;
            }
         }
      }
   }
   @media screen and (max-width: 500px) {
      padding-top: 0;
      & ${Content} {
         & .contentSlide {
            & .title {
               font-size: 1.4em;
            }
         }
      }
   }
`;

export const LinkCarousel = styled(Link)`
   display: flex;
   align-items: center;
   border: none;
   text-decoration: none;
   cursor: pointer;
   width: 30%;

   margin-top: 2.5em;

   & .text {
      font-weight: 300;
      font-size: 1.5em;
      color: white;
      font-weight: 400;
      text-transform: capitalize;
      line-height: 1em;
   }

   & img.imgTo {
      filter: brightness(2.5);
      margin-left: 1.5em;
      width: 25px;
      height: 25px;
      margin-top: 6px;
   }

   @media screen and (max-width: 1600px) {
      & .text {
         font-size: 0.9em;
      }

      & img.imgTo {
         width: 18px;
         height: 18px;
         margin-top: 0;
         margin-left: 1em;
      }
   }
   @media screen and (max-width: 500px) {
      width: 100%;
      & .text {
         font-size: 0.9em;
      }
      & img.imgTo {
         width: 1em;
         height: 1em;
      }
   }
`;

export const TextAca = styled(Text)`
   color: ${Color.textColor};
   font-size: 1.5em;
   line-height: 1.7em;
   margin-bottom: 2em;
   font-weight: 100;

   @media screen and (max-width: 1600px) {
      font-size: 1.1em;
      line-height: 1.4em;
      margin-bottom: 2.5em;
   }

   @media screen and (max-width: 500px) {
      font-size: 0.9em;
      line-height: 1.2em;
      margin-bottom: 2em;
      font-weight: 200;
   }
`;

export const TitleAca = styled(Text)`
   font-size: 2.5em;
   font-weight: 600;
   margin: ${(props) => props.margin || "0 0 2em 0"};

   @media screen and (max-width: 1600px) {
      font-size: 1.5em;
      margin: ${(props) => props.marginM || "0 0 2em 0"};
   }

   @media screen and (max-width: 500px) {
      font-size: 1.2em;
      margin: ${(props) => props.marginP || "0 0 2em 0"};
   }
`;

export const SubtitleAca = styled(Text)`
   font-size: 1.4em;
   font-weight: 500;
   margin-bottom: 0.5em;

   @media screen and (max-width: 1600px) {
      font-size: 1.1em;
   }

   @media screen and (max-width: 500px) {
      font-size: 1em;
   }
`;

export const ThinTitle = styled(Text)`
   font-weight: 200;
   font-size: 2em;
   margin-bottom: 1.5em;

   @media screen and (max-width: 1600px) {
      font-size: 1.3em;
      margin-bottom: 1em;
   }

   @media screen and (max-width: 500px) {
      font-size: 0.89em;
   }
`;

export const RowAca = styled.div`
   display: flex;
   aling-items: flex-start;
   flex-wrap: wrap;
   margin: ${(props) => props.margin || "2.4em 0 0"};
`;
const generateGridDesk = (num) => {
   let base = num ? num : 12;
   let grid = `${(100 / 12) * base}%`;
   return grid;
};
export const ColAca = styled.div`
   width: ${(props) => generateGridDesk(props.dCol)};

   &.flex {
      display: flex;
      align-items: center;
      margin-bottom: 3em;
      & p {
         margin-bottom: 0;
      }
   }

   & .attrImg {
      width: 2.8em;
      height: 2.8em;
      margin-right: 1em;
   }

   @media screen and (max-width: 1600px) {
      margin-bottom: 2.5em;
      & .attrImg {
         width: 1.99em;
         height: 1.99em;
         margin-right: 0.7em;
      }
   }
   @media screen and (max-width: 500px) {
      width: ${(props) => generateGridDesk(props.mCol)};
      margin-bottom: 0em;
      margin-top: 13px;

      & .attrImg {
         width: 1.5em;
         height: 1.5em;
         margin-right: 0.6em;
      }
   }
`;
export const CardMapAcademy = styled.div`
   width: 95%;
   margin: 0 auto;
   margin-top: -5em;
   padding: 3em 0.9em;
   background: white;

   &.noTopPadding {
      padding-top: 1em;
   }

   & ${ActionBio} {
      margin-top: 0;
   }

   &.hasIcon {
      padding-top: 2em;
      position: relative;

      & .iconCard {
         width: 4em;
         height: 4em;
         position: absolute;
         top: -2.5em;
      }
   }

   &.toBottom {
      position: absolute;
      left: 2.5%;
      bottom: -2px;
      margin-top: 0;
      padding-bottom: 2px;

      & p:last-child {
         margin-bottom: 0;
      }
   }

   @media screen and (max-width: 1600px) {
      &.hasIcon {
         & .iconCard {
            width: 3em;
            height: 3em;
            top: -2em;
         }
      }
   }
   @media screen and (max-width: 500px) {
      padding: 2em 0.7em;
      margin-top: -3em;

      &.hasIcon {
         & .iconCard {
            top: -1em;
            width: 2.5em;
            height: 2.5em;
         }
      }
   }
`;

export const ViewAcademy = styled(View)`
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: flex-start;
   margin-top: 0;

   &.noPadding {
      margin-bottom: 0;
      padding-bottom: 0;
   }

   & .experienceImg {
      width: 100%;
      height: 75vh;
      background-size: cover;
   }

   @media screen and (max-width: 500px) {
      & .experienceImg {
         height: 45vh;
         background-position: center right;
      }
   }
`;
export const Doubles = styled(ContentContainer)`
   // width: 100%;
   display: flex;
   justify-content: flex-start;

   @media screen and (max-width: 500px) {
      flex-direction: column;
   }
`;

export const ViewCardList = styled(View)`
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: flex-start;
   margin-top: 0;
   width: 49.5%;
   background: ${(props) => props.back || "white"};
   position: relative;
   margin-bottom: 2em;

   padding-top: 0;
   padding-bottom: 0;

   &:nth-child(odd) {
      margin-right: 1%;
   }

   & .experienceImg {
      width: 100%;
      height: 80vh;
      background-size: cover;
      background-position: center right;
   }

   @media screen and (max-width: 500px) {
      padding-top: 0;
      padding-bottom: 0;
      & .experienceImg {
         height: 45vh;
      }
   }
`;
export const ListPrograms = styled.div`
   width: 100%;
   height: 100%;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   // background: plum;

   @media screen and (max-width: 500px) {
      flex-direction: initial;
      padding: 0 1em;
   }
`;

export const ProgramItem = styled.div`
   display: flex;
   justify-content: flex-start;
   align-items: center;
   width: 50%;
   margin: 1em 0;

   & .iconProgram {
      margin-right: 1em;
      width: 2.88em;
      height: 2.88em;
   }

   & p {
      margin-bottom: 0;
   }

   @media screen and (max-width: 500px) {
      & .iconProgram {
         width: 2em;
         height: 2em;
      }

      & p {
         font-size: 0.7em;
      }
   }
`;

export const DescriptionAca = styled(TextAca)`
   -webkit-line-clamp: 4;
   -webkit-box-orient: vertical;
   text-overflow: ellipsis;
   -webkit-max-lines: 4;
   height: calc(4 * 1.5em * 1.1);
   overflow: hidden;
   margin-bottom: 0;

   @media screen and (max-width: 1600px) {
      font-size: 1.1em;
      line-height: 1.4em;
      height: calc(4 * 1.1em * 1.1);
   }

   @media screen and (max-width: 1400px) {
      font-size: 0.9em;
      line-height: 1.2;
      height: calc(4 * 0.9em * 1.2);
   }

   @media screen and (max-width: 800px) {
      font-size: 0.9em;
      line-height: 1.2;
      height: calc(4 * 0.9em * 1.2);
   }
`;
